module.exports = __webpack_public_path__ + "static/img/11.602bfcc5.png";